module.exports = __webpack_public_path__ + "static/media/logo.896bc345.png";